import React from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import { useTranslations } from '@vp/om-translations';
import {
  BOOKENDS_META_TAG_NAME,
  getFooterComponentSlug,
  getFooterKey,
  getHeaderComponentSlug,
  getHeaderKey,
} from '@vp/esi-bookends';

/**
 * Component that allows us to leverage translation files for page metadata.
 * Must be used within a LocalizationProvider component.
 */
export const PageMetadata = ({ metadataKey, language, bookendsConfig }) => {
  const [pageMetadata] = useTranslations([metadataKey]);

  const { headerType, footerType, hideSearch, hideVat, tenant, locale } =
    bookendsConfig;

  return (
    <Helmet>
      <html lang={language} />
      <title>{pageMetadata.pageTitle}</title>
      <meta name="description" content={pageMetadata.pageDescription} />
      <meta name="robots" content="noindex" />
      <meta
        name={BOOKENDS_META_TAG_NAME}
        data-headercomponent={getHeaderComponentSlug(headerType)}
        data-footercomponent={getFooterComponentSlug(footerType)}
        data-headerkey={getHeaderKey(
          tenant,
          locale,
          headerType,
          hideSearch,
          hideVat
        )}
        data-footerkey={getFooterKey(tenant, locale, footerType)}
        data-react-bookends-major-version="v10"
      />
    </Helmet>
  );
};

PageMetadata.propTypes = {
  language: PropTypes.string.isRequired,
  metadataKey: PropTypes.string.isRequired,
  bookendsConfig: PropTypes.object.isRequired,
};
